<template>
  <Card
    v-bind="$attrs"
    clickable
    :morph="report.timeline_morph"
    :pinned="report.timeline_pinned"
    :simple="simple"
    @click="viewingReportID = report.id"
  >
    <q-item-section>
      <div class="text-caption text-bold q-mb-xs">
        <span v-if="fullDate" class="q-pr-xs">
          ({{ $formatSystemDate(report.timeline_date, luxonFormats.SHORT_WORDED_DATE) }})
        </span>
        Report
      </div>
      <q-item-label v-if="report.address" class="module-name">
        {{ report.address }}
      </q-item-label>
      <q-item-label v-if="report.template" caption>
        {{ report.template }}
      </q-item-label>
      <q-item-label caption>
        {{ report.reference_id }}
      </q-item-label>
      <Status
        flat
        :report="report"
        class="q-mt-sm lt-sm"
      />
    </q-item-section>
    <q-item-section
      v-if="report.client"
      side
      class="text-right gt-xs"
      :title="report.client"
    >
      {{ truncateString(report.client) }}
    </q-item-section>
    <q-item-section
      side
      style="min-width: 85px;"
      class="q-pl-sm gt-xs"
    >
      <Status :report="report" />
    </q-item-section>
  </Card>

  <ReportDialog
    :id="viewingReportID"
    :disable-editing="false"
    :clone-appointment-id="cloneAppointmentId"
    without-appointment
    without-client
    @archived="onReportArchive"
    @close="viewingReportID = null"
  />
</template>

<script>
import { defineAsyncComponent } from 'vue'

import cardMixin from 'components/partials/timeline/partials/cardMixin'
import Status from 'components/app/reports/partials/Status'
import Card from 'components/partials/timeline/partials/Card'

export default {
  components: {
    Card,
    Status,
    ReportDialog: defineAsyncComponent(() => import('src/components/app/reports/partials/view/Dialog'))
  },
  mixins: [cardMixin],
  props: {
    report: {
      type: Object,
      required: true
    },
    cloneAppointmentId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      viewingReportID: null
    }
  },
  methods: {
    onReportArchive (val) {
      this.report.archived = val
    }
  }
}
</script>
